module.exports = __webpack_public_path__ + "assets/683a6d36416c8f33ebac5d6609f4e658.json";